import VuexPersistence from "vuex-persist";
import Crypto from "crypto-js";
import Cookie from "js-cookie";
import uuid from "uuid";

const cookieName = "myIpForum";
const encryptionToken = Cookie.get(cookieName) || uuid.v4();
Cookie.set(cookieName, encryptionToken, { secure: true, expires: 2 });

const persistenceAuth = new VuexPersistence({
  key: "my-ip-forum-auth",
  storage: {
    getItem: (key) => {
      const store = window.localStorage.getItem(key);
      if (store) {
        try {
          const bytes = Crypto.AES.decrypt(store, encryptionToken);

          return JSON.parse(bytes.toString(Crypto.enc.Utf8));
        } catch (e) {
          window.localStorage.removeItem(key);
        }
      }
      return null;
    },
    setItem: (key, value) => {
      const store = Crypto.AES.encrypt(value, encryptionToken).toString();

      return window.localStorage.setItem(key, store);
    },
    removeItem: (key) => window.localStorage.removeItem(key),
  },
  modules: ["auth"],
});

export default persistenceAuth;
